<template>
    <v-layout class="v-input__icon--append">
        <v-icon class="primary--text">keyboard_arrow_down</v-icon>
    </v-layout>
</template>

<script>
export default {
  name: 'SelectArrow'
}
</script>
